// samplingSites/actions.js

import { getAllSamplingSites } from "../../api/SamplingEventsApi";
import { samplingSitesInitialState } from "./samplingSitesState";

export const makeSamplingSitesActions = (set, get) => ({
  fetchSamplingSites: async () => {
    set((s) => ({
      samplingSites: { ...s.samplingSites, loading: true, error: null },
    }));
    try {
      const response = await getAllSamplingSites();
      const sites = response?.data?.sampling_sites || response?.data || [];
      set((s) => ({
        samplingSites: { ...s.samplingSites, loading: false, sites },
      }));
    } catch (err) {
      set((s) => ({
        samplingSites: {
          ...s.samplingSites,
          loading: false,
          error: err.message,
        },
      }));
      console.error("Sampling site loading error:", err);
    }
  },
  resetSamplingSites: () => set({ samplingSites: samplingSitesInitialState }),
});
